import MfButton from '@components/branded/MfButton'
import React, { useEffect, useState, useCallback } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { fetchAgencies } from '../../actions/agencies'
import brandit_rails from '../../api/brandit_rails'
import history from '../../history'
import ModalDisplay from '../ModalDisplay'

/**
 * AgencyDelete component - displays a modal to confirm deletion of an agency
 *
 * @param {Object} props - The properties of the component - only receives match object
 * @param {Object} props.match - React Router match object
 * @param {Object} props.match.params - URL parameters
 * @param {string} props.match.params.id - Agency ID
 */
const AgencyDelete = props => {
  const [agency, setAgency] = useState(null)
  const id = props.match.params.id

  useEffect(() => {
    const fetchAgency = async () => {
      try {
        const response = await brandit_rails.get(`/admin/organization/agencies/${id}`)
        setAgency(response.data)
      } catch (error) {
        console.error(error)
      }
    }
    fetchAgency()
  }, [id])

  const deleteAgency = useCallback(async () => {
    try {
      await brandit_rails.delete(`/admin/organization/agencies/${id}`)
      props.fetchAgencies().then(() => {
        history.back()
      })
    } catch (error) {
      console.error('Error deleting agency:', error)
    }
  }, [id])

  const handleCancel = useCallback(() => {
    history.back()
  }, [])

  const renderActions = useCallback(() => {
    return (
      <React.Fragment>
        <MfButton size="sm" color="danger" className="btn-left-space" onClick={deleteAgency}>
          Delete{' '}
        </MfButton>
        <MfButton size="sm" outline color="danger" className="btn-left-space" onClick={handleCancel}>
          Cancel{' '}
        </MfButton>
      </React.Fragment>
    )
  }, [deleteAgency, handleCancel])

  const renderContent = () => {
    if (!agency) {
      return (
        <div>
          Are you sure you want to delete it?
          <br />
          This operation cannot be undone.
        </div>
      )
    }

    return (
      <div>
        Are you sure you want to delete
        <br />
        <strong> {agency.name}</strong>?
        <br />
        This operation cannot be undone.
      </div>
    )
  }

  return (
    <ModalDisplay title="Attention!" content={renderContent()} actions={renderActions()} onDismiss={handleCancel} />
  )
}

const mapDispatchToProps = {
  fetchAgencies
}
export default withRouter(connect(null, mapDispatchToProps)(AgencyDelete))
